'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _theme = require('./theme');

exports.default = Object.keys(_theme.kind);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-theme/lib/kindList.js
// module id = 341
// module chunks = 4